export default {
  discoverNewFragrance: {
    en: 'Discover a new fragrance<br />every month for ${price}',
  },
  discoverNewMakeup: {
    en: 'Discover new makeup<br />every month for ${price}',
  },
}
